import { Tooltip } from "antd";
import { InfoCircle } from "iconsax-react";
import "./styles.scss";

export function FieldHint({ hint }) {
    if (!hint) return null;
    return (
        <Tooltip
            title={hint}
            trigger={["hover", "click"]}
            placement="top"
            overlayClassName="db-field-hint-tooltip"
            overlayStyle={{ zIndex: 2000 }}
            overlayInnerStyle={{
                maxWidth: 320,
                fontSize: 13,
                lineHeight: 1.6,
                textAlign: "start",
            }}
            getPopupContainer={() => document.body}
        >
            <button
                type="button"
                className="db-field-hint-btn"
                aria-label={hint}
                onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                }}
            >
                <InfoCircle size={16} aria-hidden="true" />
            </button>
        </Tooltip>
    );
}

export default function DBFieldBlock({
    children,
    title,
    error,
    required,
    span,
    hint,
    reserveHintSpace = false,
}) {
    const showLabelSuffix = Boolean(hint || reserveHintSpace);

    return (
        <div
            className="db-field-block"
            style={{ gridColumn: span && `span ${span}` }}
        >
            <label
                className={
                    showLabelSuffix ? "db-field-label--with-suffix" : undefined
                }
            >
                <span className="db-field-title">
                    {title}
                    {required ? (
                        <span className="db-field-required"> *</span>
                    ) : null}
                </span>
                {showLabelSuffix ? (
                    <span className="db-field-label-suffix">
                        {hint ? (
                            <FieldHint hint={hint} />
                        ) : (
                            <span
                                className="db-field-hint-spacer"
                                aria-hidden="true"
                            />
                        )}
                    </span>
                ) : null}
            </label>
            {children}
            {error && <div className="field-error">{error}</div>}
        </div>
    );
}
